import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function OnlineBanking(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "OnlineBanking", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.0769 14c-.5538 0-.9231-.3692-.9231-.9231C44.1538 8 40 3.84615 34.9231 3.84615c-.5539 0-.9231-.36923-.9231-.92307C34 2.36923 34.3692 2 34.9231 2 41.0154 2 46 6.98462 46 13.0769c0 .5539-.3692.9231-.9231.9231Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.3846 14c-.5538 0-.9231-.3692-.9231-.9231 0-3.0461-2.4923-5.53842-5.5384-5.53842-.5539 0-.9231-.36924-.9231-.92308 0-.55385.3692-.92308.9231-.92308 4.0615 0 7.3846 3.32308 7.3846 7.38458 0 .5539-.3692.9231-.9231.9231Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.6923 14c-.5538 0-.9231-.3692-.9231-.923 0-1.0154-.8307-1.8462-1.8461-1.8462-.5539 0-.9231-.3692-.9231-.9231 0-.55382.3692-.92306.9231-.92306 2.0307 0 3.6923 1.66156 3.6923 3.69236 0 .5538-.3692.923-.9231.923Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M11.222 24.3613H8.13867v14.3889H11.222V24.3613Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13.2784 21.2778v3.426c0 .2271-.0947.445-.2634.6056-.1686.1606-.3974.2508-.6359.2508H6.98329c-.23851 0-.46725-.0902-.6359-.2508-.16866-.1606-.26341-.3785-.26341-.6056v-3.426h7.19442Zm0 20.5556v-3.4259c0-.2272-.0947-.445-.2634-.6057-.1686-.1606-.3974-.2508-.6359-.2508H6.98329c-.23851 0-.46725.0902-.6359.2508-.16866.1607-.26341.3785-.26341.6057v3.4259h7.19442Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M23.556 24.3613h-3.0833v14.3889h3.0833V24.3613Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.6105 21.2778v3.426c0 .2271-.0948.445-.2634.6056-.1687.1606-.3974.2508-.6359.2508h-5.3959c-.2385 0-.4672-.0902-.6359-.2508-.1686-.1606-.2634-.3785-.2634-.6056v-3.426h7.1945Zm0 20.5556v-3.4259c0-.2272-.0948-.445-.2634-.6057-.1687-.1606-.3974-.2508-.6359-.2508h-5.3959c-.2385 0-.4672.0902-.6359.2508-.1686.1607-.2634.3785-.2634.6057v3.4259h7.1945Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M35.8881 24.3615h-3.0833v14.3888h3.0833V24.3615Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.9446 21.278v3.4259c0 .2272-.0947.445-.2634.6057-.1686.1606-.3974.2508-.6359.2508h-5.3958c-.2385 0-.4673-.0902-.6359-.2508-.1687-.1607-.2634-.3785-.2634-.6057V21.278h7.1944Zm0 20.5556v-3.426c0-.2271-.0947-.445-.2634-.6056-.1686-.1606-.3974-.2508-.6359-.2508h-5.3958c-.2385 0-.4673.0902-.6359.2508-.1687.1606-.2634.3785-.2634.6056v3.426h7.1944Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.119 41.8336H3.88095c-.48653 0-.88095.3451-.88095.7708v1.5417c0 .4257.39442.7708.88095.7708H39.119c.4866 0 .881-.3451.881-.7708v-1.5417c0-.4257-.3944-.7708-.881-.7708ZM21.5 11 3 16.1852v5.0926h37v-5.0926L21.5 11Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
OnlineBanking.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "OnlineBanking"
};
validateTidalLicense();
export {
  OnlineBanking
};
//# sourceMappingURL=OnlineBanking.js.map
